import type { FC, PropsWithChildren } from 'react';
import { BLOCK_ACTIONS_HOVERED_Z_INDEX, BLOCK_ACTIONS_Z_INDEX } from '@constants/z-indices';
import clsx from 'clsx';

import { blockActionsClasses } from '../classes';

interface ContainerProps extends PropsWithChildren {
  alwaysVisible?: boolean;
}

export const Container: FC<ContainerProps> = ({ children, alwaysVisible = false }) => {
  return (
    <div className={clsx(blockActionsClasses({ alwaysVisible }), BLOCK_ACTIONS_Z_INDEX, BLOCK_ACTIONS_HOVERED_Z_INDEX)}>
      {children}
    </div>
  );
};
